/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React from "react";


export const Icon = {};


Icon.Left = function (props) {

}


Icon.Delete = function (props) {
  const { title = 'Delete', ...restProps } = props;

  return (
    <I fontName="fa-trash" color='red' title={title} onClick={props.onClick} />
  );
}


Icon.CantDelete = function (props) {
  const { title = 'Unable to Delete', ...restProps } = props;

  return (
    <I fontName="fa-trash" color='grey' title={title} />
  );
}


Icon.Cancel = function (props) {
  const { title = 'Cancel', ...restProps } = props;

  return (
    <I fontName="fa-times-circle" color='red' title={title} onClick={props.onClick} />
  );
}


Icon.Add = function (props) {
  const { title = 'Add', ...restProps } = props;

  return (
    <I fontName="fa-plus" color='green' title={title} onClick={props.onClick} />
  );
}


Icon.Save = function (props) {
  const { title = 'Save', ...restProps } = props;

  return (
    <I fontName="fa-check" color='green' title={title} onClick={props.onClick} />
  );
}


Icon.Edit = function (props) {
  const { title = 'Edit', ...restProps } = props;

  return (
    <I fontName="fa-edit" title={title} onClick={props.onClick} />
  );
}


Icon.CaretLeft = function (props) {
  const { title = 'Previous', ...restProps } = props;

  return (
    <I fontName="fa-caret-left" title={title} onClick={props.onClick} />
  );
}


Icon.CaretRight = function (props) {
  const { title = 'Next', ...restProps } = props;

  return (
    <I fontName="fa-caret-right" title={title} onClick={props.onClick} />
  );
}


Icon.List = function (props) {
  const { title = 'Miltsones', selected, ...restProps } = props;

  return (
    <I fontName="fa-list" selected={selected} title={title} onClick={props.onClick} />
  );
}



Icon.Calendar = function (props) {
  const { title = 'Date picker', selected, ...restProps } = props;

  return (
    <I fontName="fa-calendar-alt" selected={selected} title={title} onClick={props.onClick} />
  );
}


Icon.Tool = function (props) {
  const { title = 'Enable tool', selected, ...restProps } = props;

  return (

    <I fontName="fa-wrench" color='green' title={title} onClick={props.onClick} />
  );
}


Icon.ToolSwitch = function (props) {
  const title = props.enabled !== true ? 'Enable tool' : 'Disable tool';

  return (
    props.enabled !== true ? <Icon.Tool onClick={props.onClick} /> : <Icon.Cancel onClick={props.onClick} /> 
  );
}



function I(props) {
  const { color = 'black', selected = false, ...restProps } = props;

  let icon_style = {
    padding: "2px 4px",

    background: selected ? '#dddddd' : '#ffffff',

    color
  }


  return (
    <i style={icon_style} className={"fas " + props.fontName} title={props.title} onClick={props.onClick}></i>
  );
}

